import React from "react";
import Img from "../Img";
import { getLabel } from "../../InitData";

export default function CheckBetButton(props) {
    // const ref = useRef(null);

    // function handleClick() {
    //     const ticketId = ref.current.value;
    //     if (ticketId.length === 0) {
    //         return;
    //     }

    //     openModal(
    //         <Modal title={'Checkbet'} type="big">
    //             <CheckBet ticketId={ticketId} />
    //         </Modal>
    //     )
    // }

    return (
        <a href={window.xs_mybetsUrl} target="_self" rel="noreferrer" className="c_7">
            <div className="c_7_1">
                <span className="c_7_1_1">{getLabel('checkbet.button')}</span>
                {/* <input className="c_7_1_2" placeholder={getLabel('prematch_page.widget.checkbet.check_bet')} ref={ref} /> */}
            </div>
            <Img className="c_7_2" src="button_chevron.svg" height="32px" width="32px" />
        </a>
    );
}
